import {baseApi} from './baseApi';
import {onQueryStartedErrorToast} from '../hooks';

export const injectedLandRegisterApi = baseApi.injectEndpoints({
    addTagTypes: ['LandRegister'],
    endpoints: (builder) => ({
        getLandRegister: builder.query({
            query: (args) => {
                const {projectId, grundbuchId, commonData, mapping} = args;

                let url = `getLandRegister?project_id=${projectId}`;

                if (grundbuchId) {
                    url += `&grundbuch_id=${grundbuchId}`;
                }

                if (commonData != null) {
                    url += `&common_data=${commonData}`;
                }

                if (mapping) {
                    let key = Object.keys(mapping)[0];
                    let value = mapping[key];
                    url += `&${key}=${value}`;
                }

                return {url: url};
            },
            providesTags: ['LandRegister']
        }),
        getGrundbuchTypes: builder.query({
            query: (args) => {
                const {} = args;
                return {url: 'getGrundbuchTypes'};
            },
            providesTags: ['LandRegister']
        }),
        createLandRegister: builder.mutation({
            query: (user) => ({
                url: 'createLandRegister',
                method: 'POST',
                body: user,
            }),
            invalidatesTags: ['LandRegister', 'Person', 'Parcel']
        }),
        updateLandRegister: builder.mutation({
            query: (user) => ({
                url: 'updateLandRegister',
                method: 'PUT',
                body: user,
            }),
            invalidatesTags: ['LandRegister', 'Person', 'Parcel']
        }),
        deleteLandRegister: builder.mutation({
            query: (user) => ({
                url: 'deleteLandRegister',
                method: 'DELETE',
                body: user,
            }),
            invalidatesTags: ['LandRegister', 'Person', 'Parcel']
        }),
    }),
});

export const {
    useGetLandRegisterQuery,
    useGetGrundbuchTypesQuery,
    useCreateLandRegisterMutation,
    useUpdateLandRegisterMutation,
    useDeleteLandRegisterMutation,
} = injectedLandRegisterApi;
